import { createAction, handleActions } from 'redux-actions'

export const populateFormErrors = createAction('POPULATE_ERROR')
export const resetErrorValues = createAction('DEFAULT_ERROR_VALUES')

// State value to populate the form errors in bootstrap modal
export const errorDialogReducer = handleActions(
  {
    POPULATE_ERROR: (state, action) => {
      return {
        messages: action.payload.messages,
        error: true,
        popupError: action.payload.popupError
      }
    },
    DEFAULT_ERROR_VALUES: (state, action) => {
      return {
        messages: [],
        error: false,
        popupError: false
      }
    }
  },
  {
    messages: [],
    error: false,
    popupError: false
  }
)



// WEBPACK FOOTER //
// ./src/redux/modules/errorDialogModule.js